import React, { useState } from 'react';
import { Filter, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { PropertyType, PriceRange } from '../../types/property';

const propertyTypes: PropertyType[] = ['house', 'apartment', 'land', 'commercial'];
const priceRanges: PriceRange[] = [
  { min: 0, max: 5000000, label: '< 5M DA' },
  { min: 5000000, max: 10000000, label: '5M - 10M DA' },
  { min: 10000000, max: 20000000, label: '10M - 20M DA' },
  { min: 20000000, max: null, label: '> 20M DA' },
];

export const PropertyFilters: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTypes, setSelectedTypes] = useState<PropertyType[]>([]);
  const [selectedPriceRange, setSelectedPriceRange] = useState<PriceRange | null>(null);

  return (
    <div className="relative">
      <Button
        variant="secondary"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2"
      >
        <Filter className="h-4 w-4" />
        Filtres
        {(selectedTypes.length > 0 || selectedPriceRange) && (
          <span className="ml-1 rounded-full bg-primary-500 px-2 py-0.5 text-xs text-white">
            {selectedTypes.length + (selectedPriceRange ? 1 : 0)}
          </span>
        )}
      </Button>

      {isOpen && (
        <div className="absolute right-0 top-12 z-10 w-72 rounded-lg bg-white p-4 shadow-lg ring-1 ring-black/5 dark:bg-gray-800">
          <div className="mb-4">
            <h3 className="mb-2 text-sm font-medium text-gray-900 dark:text-white">
              Type de bien
            </h3>
            <div className="flex flex-wrap gap-2">
              {propertyTypes.map((type) => (
                <button
                  key={type}
                  onClick={() => {
                    setSelectedTypes((prev) =>
                      prev.includes(type)
                        ? prev.filter((t) => t !== type)
                        : [...prev, type]
                    );
                  }}
                  className={`rounded-full px-3 py-1 text-sm ${
                    selectedTypes.includes(type)
                      ? 'bg-primary-500 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-200'
                  }`}
                >
                  {type}
                </button>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-2 text-sm font-medium text-gray-900 dark:text-white">
              Fourchette de prix
            </h3>
            <div className="flex flex-col gap-2">
              {priceRanges.map((range) => (
                <button
                  key={range.label}
                  onClick={() => setSelectedPriceRange(range)}
                  className={`rounded-lg px-3 py-2 text-left text-sm ${
                    selectedPriceRange === range
                      ? 'bg-primary-500 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-200'
                  }`}
                >
                  {range.label}
                </button>
              ))}
            </div>
          </div>

          {(selectedTypes.length > 0 || selectedPriceRange) && (
            <button
              onClick={() => {
                setSelectedTypes([]);
                setSelectedPriceRange(null);
              }}
              className="mt-4 flex w-full items-center justify-center gap-2 rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
            >
              <X className="h-4 w-4" />
              Réinitialiser les filtres
            </button>
          )}
        </div>
      )}
    </div>
  );
};